export interface VideoItem {
  id: string;
  creator_id: string;
  title: string;
  youtube_url: string;
  order: number;
}

export interface Creator {
  id: string;
  name: string;
  slug: string;
  niche: string;
  metric: string;
  tint: string;
  featured: boolean;
  published: boolean;
  order: number;
  videos?: VideoItem[];
}

export interface RatePackage {
  id: string;
  name: string;
  price_label: string;
  kind: string;
  inclusions: string[];
  published: boolean;
  order: number;
}

export interface HomeContent {
  tagline: string;
  hero_lines: string[];
  marquee_items: string[];
  status_text: string;
  status_published: boolean;
  rates_note: string;
  inquiry_intro: string;
}

export interface Inquiry {
  id: string;
  name: string;
  email: string;
  project_need: string;
  socials: string;
  plans: string[];
  other_details: string;
  created_at: string;
}

export const TINT_HEX: Record<string, string> = {
  mint: "#D9F7E7",
  lavender: "#EAE0F5",
  butter: "#FFF3C4",
  pink: "#FFB7D5",
  white: "#FFFFFF",
};

export const ytId = (url: string): string => {
  const m = (url || "").match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{6,})/);
  return m ? m[1] : url || "";
};
